module.exports = __webpack_public_path__ + "static/media/flag-lg.5ae8e54a.webp";